export default {
  install: function (Vue) {
    Vue.prototype.$login = async function () {
      this.$api.invalidateAll()

      let result
      try {
        result = await this.$api.user.login({ mail: this.mail, pass: this.pass })
      } catch (e) { // network error etc.
        result = false
      }

      this.showError = !result

      if (result) {
        this.$store.dispatch('user/saveData', result)
        this.$router.replace('/')
      } else {
        try {
          await this.$api.user.logout()
        } catch (e) {}
        this.$store.dispatch('user/saveData', null)
      }

      return result
    }
  }
}
